export const REVIEWERS = [
  { id: 'walter', name: 'Walter', email: 'walter.grandjean@sequesto.com' },
  { id: 'lea', name: 'Lea', email: 'lea.stiels@sequesto.com' },
  { id: 'evrard', name: 'Evrard', email: 'evrard.tserstevens@sequesto.com' },
  { id: 'patrick', name: 'Patrick', email: 'patrick.dalvinck@sequesto.com' },
] as const;

export type ReviewerId = (typeof REVIEWERS)[number]['id'];

export interface ReviewerMeta {
  userId: string;
  name: string;
  email: string;
  status: 'pending' | 'approved';
  approvedAt?: string;
  /** Slack user id resolved at send time, used to verify the button-click is from this reviewer */
  slackUserId?: string;
  /** DM channel + ts of the review-request message — used to update the message in place when they mark reviewed in OS */
  dmChannelId?: string;
  messageTs?: string;
}

export interface ReviewMeta {
  requestedBy: string;
  requestedAt: string;
  note?: string | null;
  reviewers: ReviewerMeta[];
  /** Index of the next reviewer who hasn't approved yet. Sequential reviews advance one slot at a time. */
  currentIndex?: number;
  /** Email of the requester (Walter) so we can DM them when all reviewers approve */
  requesterEmail?: string;
}
